export function trackPageView(path: string): void {
    if (typeof window.gtag !== 'function') return;

    window.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: path,
    });
}
